// CoreFeatures.jsx
import React from "react";
import { FaPlay } from "react-icons/fa";
import video from "../../assets/video/eduProHubVideo.mp4";

const features = [
  {
    title: "Simple & Easy Mock Exam Creation",
    description:
      "Create Exams Easily With An Intuitive Interface — Just Add Questions And Go Live. Multilingual Support Included.",
  },
  {
    title: "Instant Results & Analytics",
    description:
      "Get Instant Scorecards And Detailed Performance Reports Right After The Test — No Manual Evaluations Needed.",
  },
  {
    title: "Secure & Real Exam Environment",
    description:
      "From Admit Cards To Real-Time Invigilation, We Simulate The Full Exam Experience With Integrity And Control.",
  },
  {
    title: "Wide Range Of Question Types",
    description:
      "MCQs, Subjective, Fill In The Blanks, Match The Following, True/False, Essay-Type & More.",
  },
  {
    title: "Comprehensive Reporting System",
    description:
      "Scorecards, Subject-Wise Reports, Question Analytics, “Compare Yourself” Benchmarks, Admin Feedback Reports & More.",
  },
];

const CoreFeatures = () => {
  return (
    <section className="px-4 md:px-16 py-12">
      <div className="flex flex-col md:flex-row items-start gap-10">
        {/* Left - Text and Video */}
        <div className="md:w-1/2 space-y-6">
          <p className="text-lg font-outfitRegular">
            Whether you're <strong>running one center</strong> or{" "}
            <strong>scaling across cities</strong>, this demo will show you how{" "}
            <strong>Edupro Hub</strong> can simplify your system and{" "}
            <strong>level up your results.</strong>
          </p>

          <div className="relative w-full max-w-md">
            <video src={video} controls className="w-full" />
          </div>
        </div>

        {/* Right - Features List */}
        <div className="md:w-1/2">
          <h2 className="text-lg md:text-xl font-outfitRegular mb-6">
            Explore The <span className="font-bold">Core Features</span> That{" "}
            <span className="font-outfitBold">Power Edupro Hub</span>
          </h2>

          <ul className="space-y-6">
            {features.map((feature, idx) => (
              <li key={idx} className="flex items-start gap-2">
                <span className="h-3 w-3 bg-primary-900 mt-1 mr-2 rounded-[2px] rotate-[30deg] shrink-0"></span>
                <div>
                  <p className="font-outfitBold">{feature.title}</p>
                  <p className="text-sm font-outfitRegular">{feature.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CoreFeatures;
